import GraphqlReaderNode from './types/graphql-reader';

export const graphqlNodes = {
  graphqlReader: GraphqlReaderNode,
};
